import React from 'react';
import { 
    translate,
    Filter,
    List, 
    Datagrid,
    TextField, 
    DateField,
    SearchInput,

} from 'react-admin';
import Chip from '@material-ui/core/Chip';
import withStyles from '@material-ui/core/styles/withStyles';
import classnames from 'classnames';
import ErrorBoundary from '../ErrorBoundary';

const coloredStyles = {
    red:    { color: 'red' },
    yellow: { color: 'yellow' },
    blue:   { color: 'blue' },
};

const bgColoredStyles = {
    red:    { backgroundColor: 'red' },
    yellow: { backgroundColor: 'yellow' },
};

const colored = WrappedComponent => withStyles(bgColoredStyles)(
    ({ classes, ...props }) => (
        <WrappedComponent
            className={classnames({
                [classes.red]: props.record[props.source] === 'PR',
                [classes.yellow]: props.record[props.source] === 'TD' ,
            })}
            {...props}
        />
    ));


const quickFilterStyles = {
    root: {
        marginBottom: '0.7em',
    },
};

const listStyles = {
    actions: {
        backgroundColor: 'Lavender',
    },
    header: {
        backgroundColor: '#def',
        fontWeight: 'bold',
    },
    inlineBlock: {
        display: 'inline-flex', 
        marginRight: '1rem' 
    },
};

const styles = {
    inlineBlock: {
        display: 'inline-flex', 
        marginRight: '1rem' 
    },
    hidden: {
        display: 'none'
    },
    container: {
        display: 'flex',
    },
};

const QuickFilter = translate(
    withStyles(quickFilterStyles)(({ classes, label, translate }) => (
        <Chip className={classes.root} label={translate(label)} />
    ))
);



export const DonorFilter = props => (
    <Filter {...props}>
        <SearchInput source="ssn"  placeholder="SSN" alwaysOn  />
      
    </Filter>
);



export const SixMonthsList = ({ classes, permissions, ...props }) => (
    <ErrorBoundary>  
    <List 
        classes={classes}
        {...props}
        filters={<DonorFilter />}
        perPage={20}
        sort={{ field: 'first_bleed_date', order: 'DESC' }}
        bulkActionButtons ={false}
        title= "New Donors with in 6 months"
        >
        <Datagrid  classes={{ headerCell: classes.header }} >
            <TextField source="ssn"     label="SSN"/>
            <TextField source="name"    label="Name"/>      
            <DateField source="first_bleed_date"     label="First Bleed Date" locales="en-us"/>
        </Datagrid>
    </List>
    </ErrorBoundary>  
);


export default withStyles(listStyles, styles)(SixMonthsList)